import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.last-index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Message } from 'element-ui';
import { roleGame, postroleGame, rolePlatform, linkrolePlatform, roleChannel, linkroleChannel, rolePkg, linkrolePkg } from '@/api/role';
export default {
  data: function data() {
    return {
      id: '',
      dialogFormVisible: false,
      gametableData: [],
      gameSelection: [],
      platformtableData: [],
      platformSelection: [],
      channeltableData: [],
      channelSelection: [],
      pkgtableData: [],
      pkgSelection: []
    };
  },
  created: function created() {},
  methods: {
    handleSelectionChange: function handleSelectionChange(val, type) {
      this[type] = val;
    },
    toggleSelection: function toggleSelection(rows, type) {
      var _this = this;

      if (rows.length) {
        rows.forEach(function (row) {
          _this.$refs[type].toggleRowSelection(row, true);
        });
      } else {
        this.$refs[type].clearSelection();
      }
    },
    init: function init() {
      var _arguments = arguments,
          _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var id;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                id = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : 1;
                _this2.dialogFormVisible = true;

                if (!id) {
                  _context.next = 12;
                  break;
                }

                _this2.id = id;
                _context.next = 6;
                return roleGame({
                  id: id
                }).then(function (res) {
                  if (res.status == 200) {
                    _this2.gametableData = res.data.game;
                    var arr = res.data.game.filter(function (item) {
                      return res.data.role_game.lastIndexOf(item.game_id) >= 0;
                    });

                    _this2.$nextTick(function () {
                      setTimeout(function () {
                        _this2.toggleSelection(arr, 'gamemultipleTable');
                      }, 500);
                    });
                  }
                });

              case 6:
                _context.next = 8;
                return rolePlatform({
                  role_id: id
                }).then(function (res) {
                  if (res.code == 200) {
                    _this2.platformtableData = res.data;
                    var arr = res.data.filter(function (i) {
                      return i.selected;
                    });

                    _this2.$nextTick(function () {
                      setTimeout(function () {
                        _this2.toggleSelection(arr, 'platformmultipleTable');
                      }, 500);
                    });
                  }
                });

              case 8:
                _context.next = 10;
                return roleChannel({
                  role_id: id
                }).then(function (res) {
                  if (res.code == 200) {
                    _this2.channeltableData = res.data;
                    var arr = res.data.filter(function (i) {
                      return i.selected;
                    });

                    _this2.$nextTick(function () {
                      setTimeout(function () {
                        _this2.toggleSelection(arr, 'channelmultipleTable');
                      }, 500);
                    });
                  }
                });

              case 10:
                _context.next = 12;
                return rolePkg({
                  role_id: id
                }).then(function (res) {
                  if (res.code == 200) {
                    _this2.pkgtableData = res.data;
                    var arr = res.data.filter(function (i) {
                      return i.selected;
                    });

                    _this2.$nextTick(function () {
                      setTimeout(function () {
                        _this2.toggleSelection(arr, 'pkgmultipleTable');
                      }, 500);
                    });
                  }
                });

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    dataReset: function dataReset() {
      this.gametableData = [];
      this.dialogFormVisible = false;
      this.$emit("changeShow", false);
    },
    dataFormSubmit: function dataFormSubmit(e) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return postroleGame({
                  id: _this3.id,
                  game_ids: _this3.gameSelection.map(function (i) {
                    return i.game_id;
                  }).toString()
                });

              case 2:
                _context2.next = 4;
                return linkrolePlatform({
                  role_id: _this3.id,
                  platform_ids: _this3.platformSelection.map(function (i) {
                    return i.id;
                  }).toString()
                });

              case 4:
                _context2.next = 6;
                return linkroleChannel({
                  role_id: _this3.id,
                  channel_ids: _this3.channelSelection.map(function (i) {
                    return i.id;
                  }).toString()
                });

              case 6:
                _context2.next = 8;
                return linkrolePkg({
                  role_id: _this3.id,
                  pkg_ids: _this3.pkgSelection.map(function (i) {
                    return i.id;
                  }).toString()
                });

              case 8:
                Message.success('设置成功');

                _this3.$emit('refreshDataList');

                _this3.dataReset();

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};